import { useRecordContext } from 'react-admin';
import { Box, Typography, Paper, Divider } from '@mui/material';
import { AttributeItem } from './AttributeItem';

// 訂購人資訊區塊
const OrdererInfo = () => {
  const record = useRecordContext();

  return (
      <Paper sx={{ p: { xs: 2, sm: 3 }, mb: 3, width: 1200 }} elevation={2}>
          <Typography variant="h6" fontWeight="bold" gutterBottom>訂購人資訊</Typography>
          <AttributeItem label="姓名" value={record.purchaserName} />
          <AttributeItem label="手機" value={record.purchaserPhone} />
          <AttributeItem label="帳號 (E-MAIL)" value={record.purchaserEmail} />
      </Paper>
  )
}

// 收件人資訊區塊
const RecipientInfo = () => {
  const record = useRecordContext();

  return (
    <Paper sx={{ p: { xs: 2, sm: 3 }, mb: 3 }} elevation={2}>
        <Typography variant="h6" fontWeight="bold" gutterBottom>收件人資訊</Typography>
          <AttributeItem label="姓名" value={record.recipientName} />
          <AttributeItem label="手機" value={record.recipientPhone} />
          <AttributeItem label="E-MAIL" value={record.recipientEmail} />
          <AttributeItem label="地址" value={record.recipientAddr} />
    </Paper>
  )
}

// 付款資訊區塊
const PaymentInfo = () => {
  const record = useRecordContext();

  const paymentMaps = {
    credit_card: "信用卡",
    atm: "ATM轉帳",
    cvs: "超商代碼繳費"
  }

  const invoiceMaps = {
    triplicate: "三聯式",
    duplicate: "二聯式",
    electronic: "電子發票",
    donation: "捐贈碼"
  }

  return (
    <Paper sx={{ p: { xs: 2, sm: 3 }, mb: 3 }} elevation={2}>
        <Typography variant="h6" fontWeight="bold" gutterBottom>付款資訊</Typography>
        <AttributeItem label="付款方式" value={paymentMaps[record.payWay]} />
        <Divider sx={{ my: 1 }} />
        <AttributeItem label="發票類型" value={invoiceMaps[record.invoiceType]} />
        <AttributeItem label="公司抬頭" value={record.companyName} />
        <AttributeItem label="統一編號" value={record.taxId} />
    </Paper>
  )
}

// 訂購人備註區塊
const OrderNote = () => {
  const record = useRecordContext();

  return (
    <Paper sx={{ p: { xs: 2, sm: 3 } }} elevation={2}>
        <Typography variant="h6" fontWeight="bold" gutterBottom>訂購人備註</Typography>
        <Typography variant="body1" sx={{ fontWeight: 500 }}>
            {record.remark}
        </Typography>
    </Paper>
  )
}

export const OrderCustomerDetails = () => (
    <Box sx={{ mt: 3 }}>
        <OrdererInfo />
        <RecipientInfo />
        <PaymentInfo />
        <OrderNote />
    </Box>
);
